import React, { useState } from 'react';
import "./VirtualRealityPage.css";
import Navbar from "../components/Navbar";

const Training = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <Navbar />
      <div className="xr-container">
        <div className="xr-content">
          <p className="page-path">Services / Immersive Skill Training</p>
          <h5 className="xr-title">Immersive Skill Training</h5>
          <p className="subtitle">Build critical skills with safe, hands-on virtual practice</p>
          <p>
            Deliver VR-based training modules that replicate high-risk or precision-based tasks like welding or crane operation. These immersive modules enhance muscle memory and operational efficiency in a risk-free virtual environment. 
            <span className="know-toggle" onClick={() => setShowMore(!showMore)}>
              {showMore ? ' Know less' : ' Know more...'}
            </span>
          </p>

          {/* {showMore && (
            <p className="extra-text">
              These VR training modules allow users to practice complex tasks repeatedly without risk, improving skill retention and reducing on-the-job errors. Suitable for industries where safety and precision are paramount.
            </p>
          )} */}

          <div className="xr-highlights">
            <h6>Highlights:</h6>
            <ul>
              <li>Interactive VR modules replicating real-world workflows and tools</li>
              <li>Designed for manufacturing, healthcare, engineering, and other sectors</li>
              <li>Built-in performance tracking and feedback mechanisms</li>
            </ul>
          </div>
        </div>

        <div className="xr-image-wrapper">
          <img src="../images/page1image8.webp" alt="XR Workshop" className="xr-image" />
        </div>
      </div>
    </>
  )
}

export default Training;
